<app-menu-toggle
  [tooltip]="(open ? 'Close' : 'Open') + 'VP'"
  [icon]="open ? 'closevp' : 'openvp'"
  (click)="toggleVP()"
>
</app-menu-toggle>
